// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { applyMiddleware, createStore, compose } from "redux";
// import thunk from "redux-thunk";
// import reducer from "./redux/reducers";
// import { Provider } from "react-redux";
// import { BrowserRouter } from "react-router-dom";
// import { store } from "./redux/store";
// import axios from "axios";
// import Helmet from "react-helmet";
// import { ThemeProvider } from "@mui/material";
// import { logout } from "./redux/actions/auth";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// // const history = useHistory();
// axios.interceptors.request.use(
//   (req) => {
//     console.log({ req });
//     // Add configurations here FOR AXIOS
//     // const token1 = localStorage.getItem("token");
//     // // axios.defaults.headers.common[""];
//     // req.headers["Authorization"] = `Bearer ${token1}`;
//     // req.headers["source"] = `web`;
//     // console.log("Get", token1);
//     // console.log();
//     return req;
//   },
//   (err) => {
//     console.log(err);
//     return Promise.reject(err);
//   }
// );

// export var common_axios = axios.create({
//   baseURL: "http://192.168.167.66:5001/",
// });

// // TOKEN AFTER REFRESH
// const token1 = localStorage.getItem("token");

// const uid = localStorage.getItem("UserId");

// common_axios.defaults.headers.common["Authorization"] = "Bearer " + token1;
// common_axios.defaults.headers.common["source"] = "web";
// common_axios.defaults.headers.common["UserId"] = uid;

// axios.interceptors.response.use(
//   (res) => {
//     console.log({ res });
//     // Add configurations here FOR AXIOS RESPONSE
//     if (res.request.responseURL == "http://192.168.167.66:5001/auth/v1/login") {
//       if (res.data.statusDescription.statusCode == 200) {
//         // TOKEN BEFORE REFRESH OTHERWISE EXPIRED TOKEN
//         localStorage.setItem(
//           "token",
//           res.data.userDetail.userTokenDetails.jwtToken
//         );

//         localStorage.setItem("UserId", res.data.userDetail.uid);

//         const token1 = localStorage.getItem("token");

//         const userId = localStorage.getItem("UserId");

//         // const userId = localStorage.getItem("UserId");

//         common_axios.defaults.headers.common["Authorization"] =
//           "Bearer " + token1;

//         common_axios.defaults.headers.common["userId"] = userId;

//         common_axios.defaults.headers.common["source"] = "web";
//       }
//     }
//     if (
//       res.request.responseURL == "http://192.168.167.66:5001/auth/v1/pin/verify"
//     ) {
//       if (res.data.statusDescription.statusCode == 200) {
//         console.log(res.data, "hello from the other side");
//         // TOKEN BEFORE REFRESH OTHERWISE EXPIRED TOKEN
//         localStorage.setItem(
//           "token",
//           res.data.userDetail.userTokenDetails.jwtToken
//         );
//         localStorage.setItem("UserId", res.data.userDetail.uid);
//         const token1 = localStorage.getItem("token");
//         const uid = localStorage.getItem("UserId");

//         common_axios.defaults.headers.common["Authorization"] =
//           "Bearer " + token1;
//         common_axios.defaults.headers.common["UserId"] = uid;

//         common_axios.defaults.headers.common["source"] = "web";
//       }
//     }
//     console.log("code", res.data.statusDescription.statusCode);
//     if (
//       res.data.statusDescription.statusCode == 102 ||
//       res.data.statusDescription.statusCode == 303
//     ) {
//       console.log();

//       localStorage.clear();
//       window.location.pathname = "/";
//     }
//     return res;
//   },
//   (err) => {
//     console.log(err);
//     return Promise.reject(err);
//   }
// );

// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import reducer from "./redux/reducers";
import { Provider, useDispatch } from "react-redux";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { store } from "./redux/store";
import axios from "axios";
import Helmet from "react-helmet";
import { ThemeProvider } from "@mui/material";
import { logout } from "./redux/actions/auth";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
// import 'bootstrap/dist/css/bootstrap.min.css';

// // const history = useHistory();
// axios.interceptors.request.use(
//   (req) => {
//     console.log({ req });
//     // Add configurations here FOR AXIOS
//     // const token1 = localStorage.getItem("token");
//     // // axios.defaults.headers.common[""];
//     // req.headers["Authorization"] = `Bearer ${token1}`;
//     // req.headers["source"] = `web`;
//     // console.log("Get", token1);
//     // console.log();
//     return req;
//   },
//   (err) => {
//     console.log(err);
//     return Promise.reject(err);
//   }
// );

// export var common_axios = axios.create({
//   baseURL: "http://192.168.167.66:5001/",
// });

// // TOKEN AFTER REFRESH
// const token1 = localStorage.getItem("token");
// const uid = localStorage.getItem("UserId");
// common_axios.defaults.headers.common["Authorization"] = "Bearer " + token1;
// common_axios.defaults.headers.common["source"] = "web";
// common_axios.defaults.headers.common["UserId"] = uid;

// axios.interceptors.response.use(
//   (res) => {
//     console.log({ res });
//     // Add configurations here FOR AXIOS RESPONSE
//     if (
//       res.request.responseURL == "http://192.168.167.66:5001/auth/v1/login" ||
//       res.request.responseURL == "http://192.168.167.66:5001/auth/v1/pin/verify"
//     ) {
//       if (res.data.statusDescription.statusCode == 200) {
//         // TOKEN BEFORE REFRESH OTHERWISE EXPIRED TOKEN
//         localStorage.setItem(
//           "token",
//           res.data.userDetail.userTokenDetails.jwtToken
//         );
//         localStorage.setItem("UserId", res.data.userDetail.uid);
//         const token1 = localStorage.getItem("token");
//         const uid = localStorage.getItem("UserId");

//         common_axios.defaults.headers.common["Authorization"] =
//           "Bearer " + token1;
//         common_axios.defaults.headers.common["UserId"] = uid;

//         common_axios.defaults.headers.common["source"] = "web";
//       }
//     }
//     console.log("code", res.data.statusDescription.statusCode);
//     if (
//       res.data.statusDescription.statusCode == 102 ||
//       res.data.statusDescription.statusCode == 303
//     ) {

//       localStorage.clear();

//         window.location.pathname = ("/");

//     }
//     return res;
//   },
//   (err) => {
//     console.log(err);
//     return Promise.reject(err);
//   }
// );

// common_axios.interceptors.response.use(
//   (res) => {
//     console.log({ res });
//     // Add configurations here FOR AXIOS RESPONS
//     if (
//       res.data.statusDescription.statusCode == 102 ||
//       res.data.statusDescription.statusCode == 303
//     ) {

//       localStorage.clear();
//   //  alert("llal")
//         window.location.pathname = ("/")

//     }
//     return res;
//   },
//   (err) => {
//     console.log(err);
//     return Promise.reject(err);
//   }
// );

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <HashRouter>
          <App />
        </HashRouter>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
